module.exports = __webpack_public_path__ + "img/promotion_ic.8b28bb26.svg";